module.exports = __webpack_public_path__ + "img/kantine_4_a.0683f663.jpg";